module.exports = __webpack_public_path__ + "static/img/Voss.ac6b19e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Voss.jpg
// module id = Kh6E
// module chunks = 0